import { bl_cpcommerce_form_field_set_RowClass } from '../../dbschema/bl_cpcommerce_form_field_set.model';
import { BaseContainerModel } from '../base-container.model';

export class CpCommerceFormFieldSetContainerModel extends BaseContainerModel {
  bl_cpcommerce_form_field_set: bl_cpcommerce_form_field_set_RowClass = new bl_cpcommerce_form_field_set_RowClass();
}
